export type AutocompleteOption = {
  value: string
  label: string
}

export type AutocompletePreviewState =
  | 'default'
  | 'focused'
  | 'filled'
  | 'disabled'
  | 'error'
  | 'expanded'
  | 'with-tooltip'
  | 'optional'
  | 'with-info'

export const AUTOCOMPLETE_PREVIEW_STATES: AutocompletePreviewState[] = [
  'default',
  'focused',
  'filled',
  'disabled',
  'error',
  'expanded',
  'with-tooltip',
  'optional',
  'with-info',
]

export const AUTOCOMPLETE_PREVIEW_STATE_LABELS: Record<
  AutocompletePreviewState,
  string
> = {
  default: 'Default',
  focused: 'Focused',
  filled: 'Filled',
  disabled: 'Disabled',
  error: 'Error',
  expanded: 'Expanded',
  'with-tooltip': 'With tooltip',
  optional: 'Optional',
  'with-info': 'With info',
}

export const AUTOCOMPLETE_DEMO_LABEL = 'Patient name'

export const AUTOCOMPLETE_DEMO_PLACEHOLDER = 'Type to search'

export const AUTOCOMPLETE_DEMO_QUERY = 'Mo'

export const AUTOCOMPLETE_DEMO_OPTIONS: AutocompleteOption[] = [
  { value: 'moe-jones', label: 'Moe Jones' },
  { value: 'monica-giardelli', label: 'Monica Giardelli' },
  { value: 'danny-moore', label: 'Danny Moore' },
  { value: 'morgan-lee', label: 'Morgan Lee' },
  { value: 'ava-smith', label: 'Ava Smith' },
]

export const AUTOCOMPLETE_DEMO_FILLED_VALUE = 'Monica Giardelli'

export const AUTOCOMPLETE_DEMO_ERROR_MESSAGE = 'Error description'

export const AUTOCOMPLETE_DEMO_INFO_MESSAGE = 'Info text'

export type AutocompleteProps = {
  label?: string
  placeholder?: string
  options?: AutocompleteOption[]
  value?: string
  defaultValue?: string
  /** Allow values that are not in the options list. Defaults to false. */
  allowCustom?: boolean
  disabled?: boolean
  error?: boolean
  helperText?: string
  optional?: boolean
  showTooltip?: boolean
  className?: string
  /** dark-mode palette. */
  darkMode?: boolean
  /** Static visual state for the design-system showcase only. */
  previewState?: AutocompletePreviewState
  onChange?: (value: string) => void
}
